(function () {
  'use strict';

  // ── CONFIG ───────────────────────────────────────────────────────────────
  var API_URL     = 'https://phpstack-1302064-6436375.cloudwaysapps.com/chatbot/api.php';
  var BOT_NAME    = 'Hunter';
  var OPEN_DELAY  = 4000;
  var SESSION_KEY = 'hb_session';
  // ─────────────────────────────────────────────────────────────────────────

  var history      = [];
  var isOpen       = false;
  var isWaiting    = false;
  var greeted      = false;
  var pendingEmail = null;
  var sessionId    = getOrCreateSessionId();

  // ── SESSION PERSISTENCE ──────────────────────────────────────────────────
  function saveSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({ history: history, greeted: greeted }));
    } catch (e) {}
  }

  function loadSession() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      history = data.history || [];
      greeted = data.greeted || false;
    } catch (e) {}
  }

  function restoreMessages() {
    history.forEach(function (turn) {
      var role = turn.role === 'assistant' ? 'bot' : 'user';
      appendMessage(role, turn.content);
    });
  }

  // ── DOM BUILD ────────────────────────────────────────────────────────────
  function buildWidget() {
    loadSession();

    var bubble = el('button', { id: 'hb-chat-bubble', title: 'Chat with us' });
    bubble.innerHTML = iconChat();
    bubble.addEventListener('click', toggleWindow);

    var win = el('div', { id: 'hb-chat-window', class: 'hb-hidden' });

    var header = el('div', { id: 'hb-chat-header' });
    header.innerHTML =
      '<div class="hb-avatar">🦌</div>' +
      '<div><div class="hb-name">' + BOT_NAME + '</div>' +
      '<div class="hb-status">Your gear guide</div></div>';
    var closeBtn = el('button', { id: 'hb-chat-close', title: 'Close' });
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closeWindow);
    header.appendChild(closeBtn);

    var msgs = el('div', { id: 'hb-chat-messages' });

    var inputRow = el('div', { id: 'hb-chat-input-row' });
    var input    = el('textarea', { id: 'hb-chat-input', placeholder: 'Ask me anything...', rows: 1 });
    var sendBtn  = el('button', { id: 'hb-chat-send', title: 'Send' });
    sendBtn.innerHTML = iconSend();

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
    input.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 80) + 'px';
    });
    sendBtn.addEventListener('click', sendMessage);

    inputRow.appendChild(input);
    inputRow.appendChild(sendBtn);
    win.appendChild(header);
    win.appendChild(msgs);
    win.appendChild(inputRow);

    document.body.appendChild(bubble);
    document.body.appendChild(win);

    // Restore prior messages if returning to page
    if (greeted) restoreMessages();

    // Proactive greeting on cart page
    if (OPEN_DELAY > 0 && isCartPage() && !greeted) {
      setTimeout(openWithGreeting, OPEN_DELAY);
    }

    // Exit intent detection
    initExitIntent();
  }

  // ── OPEN / CLOSE ─────────────────────────────────────────────────────────
  function toggleWindow() { isOpen ? closeWindow() : openWindow(); }

  function openWindow() {
    isOpen = true;
    document.getElementById('hb-chat-window').classList.remove('hb-hidden');
    document.getElementById('hb-chat-input').focus();
    if (!greeted) sendGreeting();
  }

  function closeWindow() {
    isOpen = false;
    document.getElementById('hb-chat-window').classList.add('hb-hidden');
  }

  function openWithGreeting() {
    if (greeted) return;
    openWindow();
  }

  // ── GREETING ─────────────────────────────────────────────────────────────
  function sendGreeting() {
    greeted = true;
    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'greet', cart_count: getCartItemCount(), session_id: sessionId }),
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var greeting = data.greeting || "Hey there! Looking for something specific, or want help putting a kit together?";
      if (data.bot_name) BOT_NAME = data.bot_name;
      appendMessage('bot', greeting);
      history.push({ role: 'assistant', content: greeting });
      saveSession();
    })
    .catch(function () {
      var greeting = "Hey there! Looking for something specific, or want help putting a kit together?";
      appendMessage('bot', greeting);
      history.push({ role: 'assistant', content: greeting });
      saveSession();
    });
  }

  // ── SEND MESSAGE ─────────────────────────────────────────────────────────
  function sendMessage() {
    if (isWaiting) return;
    var input = document.getElementById('hb-chat-input');
    var text  = input.value.trim();
    if (!text) return;

    input.value = '';
    input.style.height = 'auto';
    appendMessage('user', text);

    if (pendingEmail) {
      handleEmailCapture(text);
      return;
    }

    callAPI(text);
  }

  // ── EMAIL CAPTURE ────────────────────────────────────────────────────────
  function handleEmailCapture(text) {
    var email = extractEmail(text);
    if (!email) {
      appendMessage('bot', "Hmm, I didn't catch a valid email there. What's your email address?");
      return;
    }

    var firstName = extractFirstName(text, email);
    pendingEmail  = null;
    setWaiting(true);

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ capture_email: { email: email, first_name: firstName } }),
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      setWaiting(false);
      var msg = data.subscribed
        ? "You're all set! Keep an eye on " + email + " for deals and new arrivals."
        : "Hmm, something didn't go through on my end. You can always sign up on our site directly!";
      appendMessage('bot', msg);
      history.push({ role: 'assistant', content: msg });
      saveSession();
    })
    .catch(function () {
      setWaiting(false);
      appendMessage('bot', "Couldn't connect right now. Try signing up on the site!");
    });
  }

  // ── API CALL ─────────────────────────────────────────────────────────────
  function callAPI(message) {
    setWaiting(true);
    showTyping();

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message:    message,
        history:    history,
        page_url:   window.location.href,
        cart_items: getCartItems(),
        session_id: sessionId,
      }),
    })
    .then(function (r) {
      if (!r.ok) throw new Error('API error ' + r.status);
      return r.json();
    })
    .then(function (data) {
      hideTyping();
      setWaiting(false);

      if (data.error) { appendMessage('bot', data.error); return; }

      history = data.history || history;
      appendMessage('bot', data.reply);
      saveSession();

      if (data.subscribe_action && data.subscribe_action.email) {
        subscribeDirectly(data.subscribe_action);
      } else if (data.subscribe_action && !data.subscribe_action.email) {
        pendingEmail = true;
      }
    })
    .catch(function () {
      hideTyping();
      setWaiting(false);
      appendMessage('bot', "Lost my signal there. Try asking again!");
    });
  }

  function subscribeDirectly(action) {
    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ capture_email: action }),
    }).catch(function () {});
  }

  // ── DOM HELPERS ──────────────────────────────────────────────────────────
  function appendMessage(role, text) {
    var msgs = document.getElementById('hb-chat-messages');
    var div  = el('div', { class: 'hb-msg hb-' + role });
    if (role === 'bot') {
      div.innerHTML = linkify(text);
    } else {
      div.textContent = text;
    }
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function linkify(text) {
    var escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return escaped.replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener" style="color:#2c6e3f;text-decoration:underline;">$1</a>'
    );
  }

  var typingEl = null;
  function showTyping() {
    var msgs = document.getElementById('hb-chat-messages');
    typingEl = el('div', { class: 'hb-typing' });
    typingEl.innerHTML = '<span></span><span></span><span></span>';
    msgs.appendChild(typingEl);
    msgs.scrollTop = msgs.scrollHeight;
  }
  function hideTyping() {
    if (typingEl && typingEl.parentNode) typingEl.parentNode.removeChild(typingEl);
    typingEl = null;
  }

  function setWaiting(val) {
    isWaiting = val;
    var btn = document.getElementById('hb-chat-send');
    if (btn) btn.disabled = val;
  }

  function el(tag, attrs) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    return node;
  }

  // ── SHOPIFY HELPERS ──────────────────────────────────────────────────────
  function getCartItems() {
    try {
      var cart = window.Shopify && window.Shopify.cart;
      if (cart && cart.items) {
        return cart.items.map(function (i) {
          return { title: i.title, quantity: i.quantity, price: (i.price / 100).toFixed(2) };
        });
      }
    } catch (e) {}
    return [];
  }

  function getCartItemCount() {
    try { return (window.Shopify && window.Shopify.cart && window.Shopify.cart.item_count) || 0; }
    catch (e) { return 0; }
  }

  function isCartPage() {
    return window.location.pathname === '/cart' ||
           (window.Shopify && window.Shopify.designMode === false && getCartItemCount() > 0);
  }

  // ── EXIT INTENT ──────────────────────────────────────────────────────────
  function initExitIntent() {
    if (sessionStorage.getItem('hb_exit_fired')) return; // only once per session

    var readyToFire = false;
    setTimeout(function () { readyToFire = true; }, 10000); // must be on page 10+ seconds

    document.addEventListener('mouseleave', function (e) {
      // Only fires when mouse exits toward the top (browser chrome / close button)
      if (!readyToFire || isOpen || e.clientY > 20) return;
      sessionStorage.setItem('hb_exit_fired', '1');
      triggerExitIntent();
    });
  }

  function triggerExitIntent() {
    // Pulse the bubble before opening to catch their eye
    var bubble = document.getElementById('hb-chat-bubble');
    if (bubble) {
      bubble.classList.add('hb-pulse');
      setTimeout(function () { bubble.classList.remove('hb-pulse'); }, 1400);
    }

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'exit_greet', cart_count: getCartItemCount(), session_id: sessionId }),
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var msg = data.greeting || "Hey, before you go — anything I can help you find?";

      if (greeted) {
        // Already had a conversation — inject the message into the existing chat
        openWindow();
        appendMessage('bot', msg);
        history.push({ role: 'assistant', content: msg });
        saveSession();
      } else {
        // First interaction — use it as the greeting
        greeted = true;
        openWindow();
        appendMessage('bot', msg);
        history.push({ role: 'assistant', content: msg });
        saveSession();
      }
    })
    .catch(function () { /* silent fail — don't disrupt the exit */ });
  }

  // ── SESSION ID ───────────────────────────────────────────────────────────
  function getOrCreateSessionId() {
    var key = 'hb_sid';
    var sid = sessionStorage.getItem(key);
    if (!sid) {
      sid = 'sess-' + Math.random().toString(36).slice(2) + '-' + Date.now();
      sessionStorage.setItem(key, sid);
    }
    return sid;
  }

  // ── UTIL ─────────────────────────────────────────────────────────────────
  function extractEmail(text) {
    var m = text.match(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/);
    return m ? m[0] : null;
  }

  function extractFirstName(text, email) {
    var cleaned = text.replace(email, '').replace(/[^a-zA-Z\s]/g, '').trim();
    var words   = cleaned.split(/\s+/).filter(Boolean);
    return words.length ? words[0] : '';
  }

  // ── ICONS ────────────────────────────────────────────────────────────────
  function iconChat() {
    return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M20 2H4C2.9 2 2 2.9 2 4v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>';
  }
  function iconSend() {
    return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>';
  }

  // ── INIT ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildWidget);
  } else {
    buildWidget();
  }

})();
